import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'semantic-ui-css/semantic.min.css';

var $ = require('jquery');
window.jQuery = $;
require('jquery/dist/jquery.min.js')
require('semantic-ui-css/semantic.js')

import i18n from './i18n'

Vue.baseUrl = Vue.prototype.baseUrl = ''//'http://192.168.180.150:3000'

const AppEventBus = new Vue()
Vue.prototype.$bus = AppEventBus

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
